module.exports = __webpack_public_path__ + "media/images/athletes/2199-e49cf8861c40a7126987c37194490c04.png";